import { render, staticRenderFns } from "./DoctorAssistantRelationForm.vue?vue&type=template&id=15038bcf&"
import script from "./DoctorAssistantRelationForm.vue?vue&type=script&lang=js&"
export * from "./DoctorAssistantRelationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports